module.exports = __webpack_public_path__ + "static/img/status-check.f832adab.svg";